import { useEffect } from 'react';

import { Form } from 'antd';
import { isSharedIdentificationFeatureEnabled } from 'constant';

import ArticleGroupFields from './article-group-fields';
import { getMainMemberPayload } from './main-member';
import { getShareIdentificationPayload } from './share-identification';

const FORM_ID = 'article-group-form';

/**
 * Yeni madde grubu oluşturma formu. Kendi useForm instance'ını yönetir.
 * @param {Object} props
 * @param {Function} props.onSubmit - Submit callback ({ name, members: [{ articleOffer, position }], mainMemberArticleOffer?, shareIdentification? })
 * @param {{ offerId: string, offerTitle: string, offerNumericId: number, offerStatus: number, offerStep: number }} [props.autoAddArticle] - Otomatik eklenecek madde
 */
function ArticleCreateForm({ onSubmit, autoAddArticle }) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!autoAddArticle) return;

    const currentMembers = form.getFieldValue('members') ?? [];
    const alreadyExists = currentMembers.some((m) => m.id === autoAddArticle.offerNumericId);
    if (alreadyExists) return;

    form.setFieldsValue({
      members: [
        ...currentMembers,
        {
          id: autoAddArticle.offerNumericId,
          '@id': autoAddArticle.offerId,
          label: autoAddArticle.offerTitle,
          status: autoAddArticle.offerStatus,
          step: autoAddArticle.offerStep,
          isMain: currentMembers.length === 0,
        },
      ],
    });
  }, [autoAddArticle, form]);

  const handleFinish = (values) => {
    const formMembers = values.members ?? [];
    const members = formMembers.map((member, index) => ({
      articleOffer: member['@id'],
      position: index + 1,
    }));

    // Yeni grup ortak başlamaz; anahtar açılmadıkça alan gönderilmez.
    onSubmit({
      name: values.name,
      members,
      ...getMainMemberPayload(formMembers),
      ...getShareIdentificationPayload(Boolean(values.shareIdentification), false),
    });
  };

  return (
    <ArticleGroupFields
      form={form}
      formId={FORM_ID}
      onFinish={handleFinish}
      showSharePanel={isSharedIdentificationFeatureEnabled}
    />
  );
}

export default ArticleCreateForm;
